import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import useAppContext from 'flow/hooks/useAppContext';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';

interface Props {
    number?: string;
}
const PhoneNumber = ({ number }: Props) => {
    const { i18next } = useAppContext();
    const countryCode = useAppSelector(selectUserCountryCode);

    if (!number) return null;

    if (number === 'unknown' || number === 'anonymous') {
        return i18next.t('call.hidden_number');
    }

    return (
        <NumberWrapper>
            {prettyFormatE164Number(number, countryCode)}
        </NumberWrapper>
    );
};

export default PhoneNumber;
